import { render, staticRenderFns } from "./ContactListFilters.vue?vue&type=template&id=8fcf4990"
import script from "./ContactListFilters.vue?vue&type=script&lang=ts"
export * from "./ContactListFilters.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports